import Colors from 'enums/Colors';
import styled from 'styled-components';

const CorrespondentImagemStyled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    `,

    Title: styled.h1`
        align-items: center;
        font-family: 'Barlow';
        font-weight: 600;
        font-size: 22px;
        line-height: 25.2px;
        letter-spacing: 0%;
        vertical-align: middle;
        color: ${Colors.Blue};
    `,

     TitleFeed: styled.h1`
        color: ${Colors.Blue};
        font-size: 28px;
        font-weight: 700;
    `,
};

export default CorrespondentImagemStyled;
